const CANTONS = [
  { code: 'AG', names: ['aargau', 'ag'] },
  { code: 'AI', names: ['appenzell innerrhoden', 'appenzell innerrh.', 'ai'] },
  {
    code: 'AR',
    names: ['appenzell ausserrhoden', 'appenzell ausserrh.', 'ar'],
  },
  { code: 'BE', names: ['bern', 'berne', 'be'] },
  {
    code: 'BL',
    names: ['basel-landschaft', 'basel landschaft', 'baselland', 'bl'],
  },
  { code: 'BS', names: ['basel-stadt', 'basel stadt', 'baselstadt', 'bs'] },
  { code: 'FR', names: ['fribourg', 'freiburg', 'fr'] },
  { code: 'GE', names: ['geneve', 'genf', 'geneva', 'genève', 'ge'] },
  { code: 'GL', names: ['glarus', 'gl'] },
  { code: 'GR', names: ['graubunden', 'graubuenden', 'grigioni', 'gr'] },
  { code: 'JU', names: ['jura', 'ju'] },
  { code: 'LU', names: ['luzern', 'lucerne', 'lu'] },
  { code: 'NE', names: ['neuchatel', 'neuchâtel', 'ne'] },
  { code: 'NW', names: ['nidwalden', 'nw'] },
  { code: 'OW', names: ['obwalden', 'ow'] },
  {
    code: 'SG',
    names: ['st gallen', 'st. gallen', 'stgallen', 'sankt gallen', 'sg'],
  },
  { code: 'SH', names: ['schaffhausen', 'sh'] },
  { code: 'SO', names: ['solothurn', 'so'] },
  { code: 'SZ', names: ['schwyz', 'sz'] },
  { code: 'TG', names: ['thurgau', 'tg'] },
  { code: 'TI', names: ['ticino', 'tessin', 'ti'] },
  { code: 'UR', names: ['uri', 'ur'] },
  { code: 'VD', names: ['vaud', 'vd'] },
  { code: 'VS', names: ['valais', 'wallis', 'vs'] },
  { code: 'ZG', names: ['zug', 'zg'] },
  { code: 'ZH', names: ['zurich', 'zuerich', 'zürich', 'zh'] },
];

function normalize(s) {
  if (!s && s !== 0) return '';
  // NFD + remove combining diacritics, lowercase, replace punctuation with spaces, collapse spaces
  return String(s)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(new RegExp('[-.,()\\\\/]+', 'g'), ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function toTitleCase(s) {
  if (!s && s !== 0) return '';
  return String(s)
    .split(' ')
    .map((w) => (w.length ? w[0].toUpperCase() + w.slice(1) : w))
    .join(' ');
}

// Export a simple list of cantons for UI dropdowns
export const CANTON_LIST = CANTONS.map((c) => ({
  code: c.code,
  // use the first name variant and title-case it for display
  name: toTitleCase(c.names[0]),
}));

const LOOKUP = new Map();
for (const c of CANTONS) {
  for (const n of c.names) LOOKUP.set(normalize(n), c.code);
  LOOKUP.set(normalize(c.code), c.code); // allow lookup by code string (lowercased)
}
const CODES = new Set(CANTONS.map((c) => c.code));

/**
 * Get ISO two-letter canton code from a canton name or code.
 * Returns the uppercase two-letter code or null if not found.
 */
export function getCantonCode(input) {
  if (input == null) return null;
  const s = String(input).trim();
  if (!s) return null;

  const up = s.toUpperCase();
  if (/^[A-Z]{2}$/.test(up) && CODES.has(up)) return up;

  const key = normalize(s);
  return LOOKUP.has(key) ? LOOKUP.get(key) : null;
}

export default getCantonCode;
